import VInputNumber from "./main";

export default VInputNumber;
